import ThirdContentBox from "./ThirdContentBox";

export default ThirdContentBox;
